import Auth from "../../shared/Auth";
import Globals from "../../shared/Globals";
import { qreq } from "../../shared/qrequest";
import AppActions from "../AppActions";
import BaseCom from "../BaseCom";
import Card from "../Card";
import FormInput from "../FormInput";
import Icon from "../Icon";
import { Pop } from "../PopModal";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";

class PackageSlip extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            item: {},
            errors: [],
            validated: false
        };
    }

    async componentDidMount() {
        await this.load();
        await this.loadPO();
    }

    load = async () => {
        try {
            let j = await qreq.getAsync('/api/package-slip/po/' + this.props.params.poID);
            if (j.item) {
                this.setState({ item: j.item });
                this.validate(j.item);
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    loadPO = async () => {
        try
        {
            await this.fillItemAsync('/api/purchase-order/get/' + this.props.params.poID, 'purchaseOrder');
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    submit = (e) => {
        e?.preventDefault();
        Pop.showConfirm(<div>Are you sure you want to package this packing slip?</div>, 'Send Packing Slip', async () => {
            this.setState({ submitting: true });
            try {
                let j = await qreq.postAsync('/api/package-slip/send', this.state.item);
                if (j.errorCode === 0) {
                    this.success('Packing slip sent.');
                    this.goBack();
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                this.unkownErrorCallback(e);
            }
            this.setState({ submitting: false });
        });
    }

    validate = (item) => {
        let errors = [];
        item?.items?.forEach((item, idx) => {
            if (!item.lotNumber)
                errors.push(`Lot Number is required for item ${idx + 1}.`);
            if (!item.expirationDate)
                errors.push(`Expiration Date is required for item ${idx + 1}.`);
        });
        this.setState({ errors, validated: errors.length === 0 });
        return errors.length === 0;
    }

    downloadPDF = () => {
        window.open(Globals.serverUrl + '/api/package-slip/pdf/' + this.state.item.id + '/packing-slip-' + this.state.purchaseOrder.iid + '.pdf', '_blank');
    }

    downloadCSV = () => {
        window.open(Globals.serverUrl + '/api/package-slip/csv/' + this.state.item.id + '/packing-slip-' + this.state.purchaseOrder.iid + '.csv', '_blank');
    }

    render() {
        return (
            <div className="container-fluid">
                <h1>Packing Slip</h1>
                <form onSubmit={this.submit}>
                    <AppActions>
                        {this.state.validated && !this.state.item?.isSent && <button type="submit" className="btn btn-success btn-lg" disabled={this.state.submitting}>
                            <Icon icon="faBox" /> Package
                        </button>}
                        
                        {this.state.item?.isSent && <>
                        <button type="button" className="btn btn-primary btn-lg" onClick={this.downloadPDF}>
                            <Icon icon="faFilePdf" /> PDF
                        </button>
                        <button type="button" className="btn btn-secondary btn-lg" onClick={this.downloadCSV}>
                            <Icon icon="faFileCsv" /> CSV
                        </button>
                        </>}
                    </AppActions>

                    <Card title="Packing Slip">
                        <FormInput model={this.state.item}
                            name="shippingCarrierID"
                            label="Shipping Carrier"
                            type="select"
                            selectDefault="FedEx"
                            disabled={true}
                            options={[{ id: 0, name: 'FedEx' }]} />
                        <FormInput model={this.state.item}
                            name="trackingNumber"
                            label="Tracking Number"
                            disabled={!Auth.hasRole('manager') || this.state.item?.isSent} />
                        <p className="text-muted">You can submit the packing slip without a tracking number, then add the tracking number once shipped.</p>
                    </Card>

                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Code</th>
                                <th>Item</th>
                                <th>Size</th>
                                <th>Lot Number</th>
                                <th>Expiration Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.item?.items?.map((item, idx) => (
                                <tr key={idx}>
                                    <td>{idx+1}</td>
                                    <td>{item.catalogCode}</td>
                                    <td>{item.productName}</td>
                                    <td>{item.productSize}</td>
                                    <td>{item.lotNumber}</td>
                                    <td>{Globals.toMDYDateString(item.expirationDate)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </form>
            </div>
        );
    }
}

export default withParamsAndNavigate(PackageSlip);